module.exports = __webpack_public_path__ + "static/media/agronomist_a copy.731f7996.svg";